///
/// EarthBrowser
///
/// Migration v50 to v51: Add terrain rendering settings
/// Created by Matt Giger on 10/16/2026
/// Copyright (c) 2026 Geodata Labs
///

/**
 * Migration: v50 to v51
 *
 * Changes:
 * - Seeds earthbrowser.terrainSettings (1.2x vertical exaggeration, the
 *   value the shaders hard-coded until now, and the sunrise/sunset relief
 *   light on) for the Layers panel terrain controls.
 */
interface StateV50 {
	earthbrowser?: {
		terrainSettings?: unknown
	}
}

export function migrateV50toV51(state: unknown): unknown {
	const s = state as StateV50 | null | undefined
	if (!s?.earthbrowser || s.earthbrowser.terrainSettings !== undefined) return state

	return {
		...s,
		earthbrowser: {
			...s.earthbrowser,
			terrainSettings: {
				exaggeration: 1.2,
				sunLight: true,
			},
		},
	}
}
